import React, { useContext, useEffect, useState } from "react";
import { AuthContext, AuthDispatchContext } from "../../contexts/authContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FieldValues, useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import * as joi from "joi";
import Turnstile from "react-turnstile";

const schema = joi
  .object({
    username: joi.string().required(),
    password: joi.string().required(),
  })

export default function LogIn() {
  const authContext = useContext(AuthContext);
  const authDispatchContext = useContext(AuthDispatchContext);
  const navigate = useNavigate();
  const [turnstileToken, setTurnstileToken] = useState('');
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const {
      register,
      handleSubmit,
      setError,
      formState: { errors },
    } = useForm({
      resolver: joiResolver(schema),
    });

  async function onSubmit(fieldData: FieldValues) {
    try {
      const baseUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${baseUrl}/auth/login`, {
        username: fieldData.username,
        password: fieldData.password,
        turnstileToken
      });
      if (response.status === 200) {
        const data = response.data;
        if (authDispatchContext) {
          authDispatchContext({
            type: "SET",
            authInfo: {
              username: fieldData.username,
              bearerToken: data.token
            },
          });
          setShouldRedirect(true);
        }
      }
    } catch (e: any) {
      if (e.response?.data?.code === "INVALID_CREDENTIALS") {
        setError("invalid", {
          type: "manual",
          message: "You have entered an invalid username or password",
        });
      }
      console.log(e);
    }
  }

  useEffect(() => {
    if (shouldRedirect && authContext?.authApiClient) {
      navigate("/vote");
    }
  }, [authContext, shouldRedirect, navigate]);

  return (
    <div className="flex flex-col max-w-lg mx-auto mt-16">
      <h2 className="text-center mb-11 font-bold">LOG IN</h2>
      <form
        className="flex flex-col gap-11"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col gap-1">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            {...register("username", { required: true })}
            placeholder="Username"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            {...register("password", { required: true })}
            placeholder="Password"
            required
          />
        </div>
        <Turnstile
          sitekey="0x4AAAAAACH7cmytUTEveGuQ"
          onVerify={(token) => setTurnstileToken(token)}
        />
        <div className="flex flex-col gap-1">
          {errors.invalid && (
            <div className="text-sm text-rose-500 self-center">
              {errors.invalid.message?.toString()}
            </div>
          )}
          <button
            type="submit"
            className="btn-primary w-fit px-8 py-3 self-center"
          >
            LOG IN
          </button>
        </div>
      </form>
      <div className="text-sm text-center">
        <div>Don't have an account ?</div>
        <a className="underline" href="/auth/signup">
          Create an account
        </a>
      </div>
    </div>
  );
}
